import authInitializer from 'modules/auth/authInitializer';
import firebaseInitializer from 'modules/shared/firebase/firebaseInitializer';

export default [firebaseInitializer, authInitializer];
